import React from 'react';
import { Button, Icon } from '@tencent/spaui';
import { withAccountList } from '../../cacheAPIData/withAccountList';
import { PageUtil } from '../../utils/PageUtil';

const AccountInfoCardInner = (props = {}) => {
  const { value, className } = props;
  const showPersionalConfig =
    window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
    window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER' ||
    window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE' ||
    window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER';
  const onSwitchAccount = (account) => {
    const newUrl = `${window.location.origin}/advertiser/${account.accountId}`;
    if(window.pageProps.source == 'qw') {
      window.pageProps.uid = account.accountId;
      const callback = () => props.setRouter(PageUtil.getAuthedRoutes());
      // 调用init函数
      PageUtil.initWithCallback(callback);
    } else if (account.accountStatus !== 1) {
      window.open(newUrl, '_blank');
    } else {
        window.location = newUrl;
    }
  };
  return (
    <li className={`${className} spaui-topnav-drop`}>
      <a className="nav-link" href="#">
        {props.uname}
        <i className="icon-darr"></i>
      </a>
      <div className="spaui-topnav-menu my-card">
        <div className="feed-item">
          <div className="feed-img">{/* <img src="http://ui.qzone.com/80x80" alt=""/>*/}</div>
          <div className="feed-info">
            <div className="feed-title">{props.uname}</div>
            <div className="feed-desc">账户ID:{window.pageProps.uid}</div>
            <div className="feed-desc">登录用户:{props.loginUserName}</div>
          </div>
        </div>
        {(window.pageProps.authenticationWay === 'SSO_LOGIN' || window.pageProps.source == 'qw') && (
          <div className="multi-account">
            <div className="titlebar">
              <h3 className="title" title="全部账户">
                全部账户
              </h3>
            </div>
            {props.accountList.map((account, index) => (
              <div className="account-item" key={index} onClick={() => onSwitchAccount(account)}>
                <div className="account-name">{account.accountName}</div>
                <div className="account-desc">{`ID: ${account.accountId}`}</div>
                {window.pageProps.uid == account.accountId && (
                  <div className="account-checked">
                    <Icon type="checkmark" />
                  </div>
                )}
                {window.pageProps.uid != account.accountId && <div className="account-tips">切换账号</div>}
              </div>
            ))}
          </div>
        )}
        <div className="my-card-footer">
          <Button onClick={props.showIndividualModal} disabled={!showPersionalConfig}>
            个人设置
          </Button>
          <i className="spaui-icon spaui-icon-divier"></i>
          <Button onClick={props.logout}>退出</Button>
        </div>
      </div>
    </li>
  );
};

export default withAccountList(AccountInfoCardInner);
